module.exports = __webpack_public_path__ + "img/videoplay.93c3b15e.svg";